import { useMarket } from "@app/_context";
import { useMemo } from "react";
import type { StockProps } from "./Stock.types";
import { getStockStatus } from "./Stock.utils";

export function useStockStatus({ item, type }: StockProps) {
  const { market } = useMarket().state;

  const status = useMemo(() => {
    if (!item) return undefined;

    if (type === "pdp" || type === "plp") {
      return getStockStatus({
        type,
        item,
        market,
      });
    }

    if (type === "cart" || type === "checkout") {
      return getStockStatus({
        type,
        item,
        market,
      });
    }
  }, [item, type, market]);

  return status;
}
